import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { GraduationCap, Briefcase, Code2, ArrowRight } from 'lucide-react';
import { aboutInfo } from '../data/mockData';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            About Me
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {aboutInfo.description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          {/* Education */}
          <Card className="h-full">
            <CardContent className="p-8">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-blue-100 rounded-lg mr-4">
                  <GraduationCap size={24} className="text-blue-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Education</h3>
              </div>
              {aboutInfo.education.map((edu, index) => (
                <div key={index} className="border-l-2 border-blue-200 pl-6 ml-6">
                  <div className="flex items-center mb-2">
                    <h4 className="text-lg font-semibold text-gray-900">{edu.degree}</h4>
                    <Badge variant="secondary" className="ml-2">{edu.status}</Badge>
                  </div>
                  <p className="text-gray-600 mb-1">{edu.institution}</p>
                  <p className="text-sm text-gray-500">{edu.duration}</p>
                </div>
              ))}
            </CardContent>
          </Card>

          {/* Experience */}
          <Card className="h-full">
            <CardContent className="p-8">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-green-100 rounded-lg mr-4">
                  <Briefcase size={24} className="text-green-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Experience</h3>
              </div>
              {aboutInfo.experience.map((exp, index) => (
                <div key={index} className="border-l-2 border-green-200 pl-6 ml-6">
                  <h4 className="text-lg font-semibold text-gray-900 mb-1">{exp.position}</h4>
                  <div className="flex items-center mb-2">
                    <p className="text-gray-600">{exp.company}</p>
                    <ArrowRight size={16} className="mx-2 text-gray-400" />
                    <p className="text-sm text-gray-500">{exp.duration}</p>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed">{exp.description}</p>
                </div>
              ))}
            </CardContent>
          </Card>
        </div>

        {/* Skills */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-6">
            <div className="p-3 bg-purple-100 rounded-lg mr-4">
              <Code2 size={24} className="text-purple-600" />
            </div>
            <h3 className="text-3xl font-bold text-gray-900">Technical Skills</h3>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {aboutInfo.skills.map((skillGroup, index) => (
            <Card key={index} className="h-full">
              <CardContent className="p-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-4">{skillGroup.category}</h4>
                <div className="flex flex-wrap gap-2">
                  {skillGroup.items.map((skill, skillIndex) => (
                    <Badge
                      key={skillIndex}
                      variant="secondary"
                      className="text-sm"
                    >
                      {skill}
                    </Badge>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;